
import { useState } from 'react';

interface BulkActionResult {
  gameId: string;
  gameTitle: string;
  success: boolean;
  error?: string;
}

export const useAdminGamesBulkActions = () => {
  const [selectedGames, setSelectedGames] = useState<string[]>([]);
  const [bulkAction, setBulkAction] = useState('');
  const [bulkCategory, setBulkCategory] = useState('');
  const [bulkFakePlayCount, setBulkFakePlayCount] = useState('');
  const [bulkFakePlayMin, setBulkFakePlayMin] = useState('');
  const [bulkFakePlayMax, setBulkFakePlayMax] = useState('');
  const [bulkRatingsCountMin, setBulkRatingsCountMin] = useState('');
  const [bulkRatingsCountMax, setBulkRatingsCountMax] = useState('');
  const [useFakePlayRange, setUseFakePlayRange] = useState(false);
  
  // Progress tracking states
  const [progressDialogOpen, setProgressDialogOpen] = useState(false);
  const [progressData, setProgressData] = useState({
    action: '',
    totalGames: 0,
    processedGames: 0,
    results: [] as BulkActionResult[],
    isComplete: false
  });

  const clearBulkSelection = () => {
    setSelectedGames([]);
    setBulkAction('');
    setBulkCategory('');
    setBulkFakePlayCount('');
    setBulkFakePlayMin('');
    setBulkFakePlayMax('');
    setBulkRatingsCountMin('');
    setBulkRatingsCountMax('');
    setUseFakePlayRange(false);
  };

  const startProgress = (action: string, totalGames: number) => {
    setProgressData({
      action,
      totalGames,
      processedGames: 0,
      results: [],
      isComplete: false
    });
    setProgressDialogOpen(true);
  };

  const updateProgress = (processedGames: number, results: BulkActionResult[]) => {
    setProgressData(prev => ({
      ...prev,
      processedGames,
      results
    }));
  };

  const completeProgress = () => {
    setProgressData(prev => ({
      ...prev,
      isComplete: true
    }));
  };

  const getFailedGameIds = () => {
    return progressData.results
      .filter(result => !result.success)
      .map(result => result.gameId);
  };

  return {
    selectedGames,
    setSelectedGames,
    bulkAction,
    setBulkAction,
    bulkCategory,
    setBulkCategory,
    bulkFakePlayCount,
    setBulkFakePlayCount,
    bulkFakePlayMin,
    setBulkFakePlayMin,
    bulkFakePlayMax,
    setBulkFakePlayMax,
    bulkRatingsCountMin,
    setBulkRatingsCountMin,
    bulkRatingsCountMax,
    setBulkRatingsCountMax,
    useFakePlayRange,
    setUseFakePlayRange,
    clearBulkSelection,
    // Progress tracking
    progressDialogOpen,
    setProgressDialogOpen,
    progressData,
    startProgress,
    updateProgress,
    completeProgress,
    getFailedGameIds
  };
};
